import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * QR del otpauth:// generado en el navegador como imagen data: (sin servicios externos ni innerHTML).
 * La data URL vive solo en el estado del componente y se descarta al desmontar.
 */
export function TotpQr({ uri, label }: { uri: string; label: string }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(uri, { margin: 1, errorCorrectionLevel: 'M', width: 192 })
      .then((d) => { if (alive) setSrc(d); })
      .catch(() => { if (alive) setSrc(''); });
    return () => { alive = false; setSrc(''); };
  }, [uri]);
  return (
    <div className="w-48 h-48 p-2 bg-white rounded-[var(--c-card-radius)] border border-border-default" data-test="totp-qr">
      {src ? <img src={src} alt={label} width={176} height={176} className="w-full h-full" /> : <div role="img" aria-label={label} aria-busy="true" className="w-full h-full" />}
    </div>
  );
}
